import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { L as LabelContainer } from './LabelContainer-B-AAu4SJ.js';

function NumericLabel({
  checked,
  disabled,
  label,
  value,
  ...restProps
}) {
  return /*#__PURE__*/React__default.createElement(LabelContainer, _extends({}, restProps, {
    checked: checked,
    disabled: disabled,
    label: label
  }), value);
}

export { NumericLabel as N };
//# sourceMappingURL=NumericLabel-C43p7PpZ.js.map
